import ArticleMediaApi from './ArticleMediaApi';
export default ArticleMediaApi;
